import { Link } from "react-router-dom";
import { Flame } from "lucide-react";

const CARE_ITEMS = [
  "Trim wick to 1/4” before each lighting",
  "Burn for max 3 hours per session",
  "Place on a stable, heat-safe surface",
  "Keep away from drafts, children, pets, and flammable objects",
  "Never leave a burning candle unattended",
  "Allow candle to cool before handling",
];

export default function CandleCareSafety({ compact = false }) {
  return (
    <div data-testid="candle-care-safety">
      {compact ? (
        <div className="flex items-center gap-2 mb-3">
          <Flame size={14} strokeWidth={1.8} className="luxe-text" />
          <h3 className="text-[11px] uppercase tracking-[0.25em] font-bold">Candle Care &amp; Safety</h3>
        </div>
      ) : (
        <div className="text-center mb-8">
          <div className="text-[10px] uppercase tracking-[0.3em] font-semibold text-zinc-500 mb-4 flex items-center justify-center gap-2">
            <Flame size={14} strokeWidth={1.8} className="luxe-text" />
            Burn with intention
          </div>
          <h2
            className="text-3xl md:text-4xl font-black tracking-tight"
            style={{ fontFamily: "Outfit" }}
          >
            Candle Care &amp; Safety
          </h2>
        </div>
      )}

      <ul
        className={
          compact
            ? "space-y-2"
            : "grid sm:grid-cols-2 gap-x-10 gap-y-3 max-w-2xl mx-auto text-left"
        }
      >
        {CARE_ITEMS.map((item) => (
          <li
            key={item}
            className={`flex items-start gap-2.5 ${compact ? "text-[11px]" : "text-sm"} text-zinc-600 leading-snug`}
          >
            <span
              className="mt-1.5 w-1.5 h-1.5 rounded-full luxe-bg shrink-0"
              aria-hidden
            />
            <span>{item}</span>
          </li>
        ))}
      </ul>

      <div className={`border-t border-zinc-200 ${compact ? "mt-4 pt-3" : "mt-8 pt-6 max-w-2xl mx-auto"}`} />
      <p
        className={`${compact ? "text-[11px]" : "text-sm text-center max-w-2xl mx-auto"} text-zinc-500 leading-relaxed`}
        data-testid="wholesale-note"
      >
        For wholesale orders, please{" "}
        <Link
          to="/contact"
          className="luxe-text font-semibold underline underline-offset-2 hover:opacity-80"
          data-testid="wholesale-contact-link"
        >
          contact us
        </Link>{" "}
        directly for bulk purchasing.
      </p>
    </div>
  );
}
